import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
// import HomeMain from "@/components/HomeMain";
import CustomerCase from "@/components/CustomerCase";
import CloudDesktop from "@/components/cloudDesktop";
import AtenCamera from "@/components/atenCamera";
import NewsLists from "@/components/newsLists";
import NewsDetial from "@/components/NewsDetial";
import Contact from "@/components/Contact";

import OneMachine from "@/components/oneMachine";
import AboutUs from "@/components/aboutUs";
import Products from "@/components/Products";
import HomeMain from "@/components/AccessPlatform";

import store from "../store";
//后台管理
import Server_login from "@/views/server_web/login/login";
import Server_home from "@/views/server_web/home/home";
import Server_news from "@/views/server_web/home/news";
import Server_editNews from "@/views/server_web/home/editNews";


Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      // name: "Home",
      component: Home,
      children: [
        {
          path: "/",
          name: "HomeMain",
          component: HomeMain
        },
        {
          path: "/products",
          component: Products,
          redirect: "/products/oneMachine",
          children: [
            {
              path: "/products/oneMachine",
              name: "oneMachine",
              component: OneMachine
            },
            // {
            //     path:"/products/cloudDesktop",
            //     name:"cloudDesktop",
            //     component:CloudDesktop
            // },
            {
              path: "/products/atenCamera",
              name: "atenCamera",
              component: AtenCamera
            }
          ]
        },
        {
          path: "/CustomerCase",
          name: "CustomerCase",
          component: CustomerCase
        },
        {
          path: "/NewsLists",
          name: "NewsLists",
          component: NewsLists
        },
        {
          path: "/NewsLists/NewsDetial/:id",
          component: NewsDetial,
          name: "NewsDetial"
        },
        {
          path: "/Contact",
          component: Contact,
          name: "Contact"
        },
        {
          path: "/aboutUs",
          component: AboutUs,
          name: "aboutUs"
        }
      ]
    },
    // 后台管理
    {
      path: "/admin",
      component: Server_home,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/",
          component: Server_news
        },
        {
          path: "/news",
          component: Server_news
        },
        {
          path: "/editNews",
          name: "editNews",
          component: Server_editNews
        }
      ]
    },
    {
      path: "/login",
      component: Server_login
    }
  ]
});

//注册全局钩子用来拦截导航
router.beforeEach((to, from, next) => {
  //获取store里面的token
  let token = store.state.token;
  //判断要去的路由有没有requiresAuth
  if (to.meta.requiresAuth) {
    if (token) {
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath } // 将刚刚要去的路由path（却无权限）作为参数，方便登录成功后直接跳转到该路由
      });
    }
  } else {
    next(); //如果无需token,那么随它去吧
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js